import { render } from "./ClearDocumentButton.vue?vue&type=template&id=0d52892a&scoped=true&ts=true"
import script from "./ClearDocumentButton.vue?vue&type=script&lang=ts"
export * from "./ClearDocumentButton.vue?vue&type=script&lang=ts"

import "./ClearDocumentButton.vue?vue&type=style&index=0&id=0d52892a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d52892a"]])

export default __exports__